/* eslint-disable max-classes-per-file */
import * as FullStory from '@fullstory/browser';
import { upgradeNg1Dependency } from '@go-modules/common/ng1-upgrade-factory';
import { FULLSTORY_EVENTS } from './fullstory.events';

export class FullstoryService {

	public userIdTracker: string;

	// Warning! Do not directly inject this.
	// You should instead inject the FullstoryProvider below,
	// which will correctly initialize the service.
	constructor (
		private $cookies: ng.cookies.ICookiesService,
		private $q: ng.IQService,
		private $interval: ng.IIntervalService,
		private FS: typeof FullStory
	) {}

	public configure (user: any) {
		if (user.user_id === this.userIdTracker) return;
		this.identify(user);
	}

	public createEvent (eventName: FULLSTORY_EVENTS, payload: object) {
		this.FS.event(eventName, payload);
	}

	public identify (user: any) {
		if (this.$cookies.get('is_self_demo_experiment') !== 'true') {
			this.userIdTracker = user.user_id;
			this.FS.identify(user.user_id.toString(), {
				displayName: user.fullname || user.full_name,
				email: user.email
			});
		}
	}

	public clearUser () {
		this.userIdTracker = null;
		this.FS.anonymize();
	}

	/**
	 * Polls and resolves when Fullstory is initialized
	 */
	public async isReady (): Promise<void> {
		return this.$q((resolve) => {
			// Immediately resolve if initialized
			if (this.FS.isInitialized()) {
				resolve();
				return;
			}

			const intervalPromise = this.$interval(() => {
				if (this.FS.isInitialized()) {
					this.$interval.cancel(intervalPromise);
					resolve();
				}
			}, 100);
		});
	}
}

export class FullstoryProvider {
	public static readonly NG1_INJECTION_NAME = 'fullstoryService' as const;
	private FS: typeof FullStory = FullStory;

	// ngInject doesn't work on $get, so we have to manually annotate
	public $get = ['$cookies', '$q', '$interval', function ($cookies: ng.cookies.ICookiesService, $q: ng.IQService, $interval: ng.IIntervalService) {
		return new FullstoryService($cookies, $q, $interval, this.FS);
	}];

	public setFS (FS: typeof FullStory) {
		this.FS = FS;
	}

	public init (orgId: string) {
		// Initing FullStory during boot so non angular parts of the code may continue using FullStory
		this.FS.init({orgId});
	}
}

export const fullstoryToken = upgradeNg1Dependency(FullstoryProvider);
